import React from "react";
import { Link } from "react-router-dom";
import { SEO } from "../components/SEO";
import { BUSINESS_INFO } from "../config";

export function ForbiddenPage() {
  return (
    <>
      <SEO
        title="403 - Adgang nægtet - Hundens Pels og Pleje"
        description="Adgang nægtet (403). Du har ikke tilladelse til at tilgå denne side hos Hundens Pels og Pleje."
      />

      <section className="flex min-h-[70vh] items-center justify-center py-20 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="mx-auto max-w-xl text-center">
          <i className="fa-solid fa-lock text-5xl text-black mb-4" aria-hidden="true" />

          <h1 className="font-heading text-3xl sm:text-4xl font-medium text-black tracking-tight">
            Ingen adgang
          </h1>

          <p className="mt-4 text-base sm:text-lg text-[#66564C] leading-relaxed">
            Dette område er lukket eller kræver særlige rettigheder. Men du er altid hjerteligt velkommen på vores forside eller til at booke tid til din hund.
          </p>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center gap-2 rounded-full border border-[#8C532B] bg-transparent px-6 py-3.5 text-sm font-bold text-[#8C532B] transition-colors hover:bg-transparent hover:text-[#5B331A] hover:border-[#5B331A]"
            >
              <i className="fa-solid fa-house" aria-hidden="true" />
              <span>Gå til forsiden</span>
            </Link>

            <a
              href={BUSINESS_INFO.bookingUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 rounded-full bg-[#dabeb9] px-6 py-3.5 text-sm font-bold text-[#331E12] shadow-xs transition-colors hover:bg-[#c9a7a0]"
            >
              <i className="fa-solid fa-calendar-check text-[#6B3E20]" aria-hidden="true" />
              <span>Book tid</span>
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
